import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0829271d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "body" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "資料を一括送信", -1))
const _hoisted_3 = { class: "breadcrumb" }
const _hoisted_4 = { class: "content has-background-contents shadow" }
const _hoisted_5 = { class: "navigation" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" トップページに戻る ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_OuterInputComplete = _resolveComponent("OuterInputComplete")!
  const _component_DssIcon = _resolveComponent("DssIcon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Breadcrumb, {
          list: _ctx.list,
          pageNum: 2
        }, null, 8, ["list"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_OuterInputComplete)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_router_link, {
        to: "/dms/outer",
        class: "button-toTop"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_DssIcon, { icon: 'arrow-left' }),
          _hoisted_6
        ]),
        _: 1
      })
    ])
  ], 64))
}